module.exports = __webpack_public_path__ + "static/media/phone-pause.cf9b1cfd.svg";